<div class="container">
  <iframe [src]="iframeSrc" #myIframe (load)="onLoadFunc(myIframe)" seamless></iframe>
</div>
